import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { useJoiners } from '../../hooks/useJoiners'
import { Base } from '../Base'

interface Props {
  employeeIds: number[]
  startDate: string
  endDate: string
}

export const Joiners = ({ employeeIds, startDate, endDate }: Props) => {
  const { fetch, data, loading } = useJoiners()

  const handleFetch = (itemsPerPage: number, lastCursor?: string) => {
    fetch({ employeeIds, startDate, endDate, itemsPerPage, lastCursor })
  }

  const formattedData = useUnsafeMemo(
    () =>
      data?.employees.employeesConnection?.edges
        .map((edge) => {
          const employee = edge.node

          return employee.contractversionsConnection.nodes.map((node) => ({
            id: String(node.id),
            date: node.startsOn ?? '',
            employeeName: employee.fullName,
            employeeId: employee.id,
            contractVersionId: String(node.id),
          }))
        })
        .flat() ?? [],
    [data]
  )

  const formattedPagination = useUnsafeMemo(() => {
    return {
      hasNextPage: data?.employees.employeesConnection?.pageInfo.hasNextPage ?? false,
      endCursor: data?.employees.employeesConnection?.pageInfo.endCursor ?? '',
      totalCount: data?.employees.employeesConnection?.totalCount ?? 0,
    }
  }, [data])

  return (
    <Base
      fetch={handleFetch}
      loading={loading}
      count={employeeIds.length}
      data={formattedData}
      type="hires"
      pagination={formattedPagination}
    />
  )
}
